import { i18nKeys } from '@kaa/i18n/providers/keys';
import React, { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';
import {
  PrestationsSearchTableRowStatusContent,
  PrestationsSearchTableRowStatusProps,
} from './PrestationsSearchTableRowStatusContent';
import { useStatusBadge } from '../../customer-status/useStatusBadge';

export const PrestationsSearchTableRowStatus = (
  props: PrestationsSearchTableRowStatusProps,
) => {
  const { t } = useTranslation();

  const {
    service: { status, remittedVouchers },
  } = props;

  const tdStyle = {
    position: 'relative',
    paddingLeft: '5rem',
  } as CSSProperties;

  const badge = useStatusBadge(status, remittedVouchers);

  return (
    <td style={tdStyle}>
      {badge}
      {t(i18nKeys.general.serviceStatus[status])}
      <PrestationsSearchTableRowStatusContent {...props} />
    </td>
  );
};
